import React from 'react'
import PropTypes from 'prop-types'
import { t } from 'i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import './PaymentMethodSection.css'

function PaymentMethodSection({
  onOpenModal,
  selectedMethod,
  isLoading = false,
}) {
  return (
    <div
      className="payment-method-section"
      data-testid="container-payment-method-section">
      <p className="payment-method-section__title">
        {t('PAYMENT_METHOD_SECTION_T.TITLE')}
      </p>
      {selectedMethod && (
        <p
          className="payment-method-section__selected"
          data-testid="text-selected-payment-method">
          {t(selectedMethod.label)}
        </p>
      )}
      <button
        type="button"
        onClick={onOpenModal}
        className="payment-method-section__btn"
        disabled={isLoading}
        aria-busy={isLoading}
        data-testid="btn-open-payment-method-modal">
        {isLoading ? (
          <>
            <FontAwesomeIcon icon={faSpinner} spin aria-hidden="true" />
            {t('PAYMENT_METHOD_SECTION_T.VERIFYING_BUTTON')}
          </>
        ) : (
          t('PAYMENT_METHOD_SECTION_T.SELECT_BUTTON')
        )}
      </button>
    </div>
  )
}

PaymentMethodSection.propTypes = {
  onOpenModal: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  selectedMethod: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }),
}

export default PaymentMethodSection
